import React, { useEffect } from "react"
import Header from "../components/Header"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"

const Confirm: React.FC = () => {
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
		})
	}, [])

	return (
		<PromoSoonOverHandler>
			<div className="relative ">
				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/promoSoonOverHeader.jpg"} />
					<img src={"/images/promoSoonOverHeader.jpg"} className=" block w-full" alt="Danke" />
				</picture>

				<h2 className="md:text-[70px] text-[25px]  absolute left-0 bottom-[40%] translate-y-1/2 w-full  text-center  ">
					Vielen Dank <span className="text-[#78BE20] block">für Deine Teilnahme!</span>
				</h2>
			</div>
			<div className="text-center pt-12 px-4">
				<h2 className="h2 text-[#A3C35B] sm:text-[49px]">
					Deine Teilnahme ist <br />
					erfolgreich bei uns eingegangen.
				</h2>
				<p className="font-CalibriRegular text-[14px] sm:text-[24px] mt-4 max-w-[905px] mx-auto px-4">
					Die Ermittlung der Gewinner erfolgt innerhalb von zwei Wochen nach Aktionsende per Zufallsziehung
					aus allen gültigen Teilnahmen. Die Gewinner werden per E-Mail über ihren Preis informiert. Solltest
					du nach Ablauf des Zeitraums keine E-Mail von uns erhalten haben, bist du leider nicht unter den
					Gewinnern.
					<br />
					<br />
					Wir wünschen Dir viel Glück!
					<br />
					Dein BULLDOG-Team
				</p>

				<div className="pb-12 pt-2 text-center">
					<img src={"/images/bulldog.png"} alt="Bulldog Produkte" className="mx-auto block max-w-[220px]  " />

					<a href="/" target="_blank" className="btn btn-green">
						Zurück zur Aktion
					</a>

					<p className="font-CalibriRegular text-[14px] sm:text-[15px] mt-8  ">
						Aktionszeitraum vom 25.05. bis 05.07.2026. <br />
						Teilnahme ab 18 Jahren. <br />
						Die Gewinner werden in den ersten zwei Wochen nach Teilnahmeschluss ermittelt.
					</p>
				</div>
			</div>
		</PromoSoonOverHandler>
	)
}
export default Confirm
